<template>
  <v-dialog :value="value" max-width="35%" :fullscreen="fullscreen" @click:outside="close" loading @keydown.esc="close" :scrollable="scrollable">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-card-text>
              <slot></slot>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Закрыть</v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "DialogView",
    props: {
      value: {
        type: Boolean,
      },
      title: {
        type: String,
        default: '',
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      scrollable: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      close() {
        this.$emit('input', false)
      },
    },

  }
</script>

<style scoped>

</style>
